import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import { StoreState } from '@ui/store/rootReducer';
import { LoadableContent } from '@ui/components';
import { citiesSelectors } from '../';
import * as actions from '../services/actions';
import CitiesList from '../components/CitiesList';

import './cities.less';

interface StateToProps {
  loading: boolean;
  cities: any[];
  region: any;
}

interface DispatchToProps {
  onLoadCities: (regionId: string) => void;
}

type Props = StateToProps & DispatchToProps & RouteComponentProps;

class Cities extends React.PureComponent<Props> {
  componentDidMount(): void {
    const { onLoadCities, match } = this.props;
    const { regionId } = match.params as any;

    onLoadCities(regionId);
  }

  handleClickCity = (city: any) => {
    const { history } = this.props;
    // почему здесь replace? из-за этого back в браузере некорректно отрабатывал
    // history.replace(`/city/${city.id}/stores`);
    history.push(`/city/${city.id}/stores`);
  };

  render(): React.ReactNode {
    const { loading, cities, region } = this.props;
    return (
      <LoadableContent loading={loading}>
        <div className="cities-page__content">
          {region && <div className="cities-page__panel">{region.name} Область</div>}
          <CitiesList cities={cities} onClick={this.handleClickCity} />
        </div>
      </LoadableContent>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  cities: citiesSelectors.getCities(state),
  loading: citiesSelectors.getLoading(state),
  region: citiesSelectors.getRegion(state),
});

const mapDispatchToProps = {
  onLoadCities: actions.citiesRequested,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Cities));



// WEBPACK FOOTER //
// ./src/scenes/Cities/containers/Cities.tsx